var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousePlanAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.25C17.5858 15.25 17.25 15.5858 17.25 16C17.25 16.4142 17.5858 16.75 18 16.75H22C22.4142 16.75 22.75 16.4142 22.75 16C22.75 15.5858 22.4142 15.25 22 15.25H20.75V2.75H22C22.4142 2.75 22.75 2.41421 22.75 2C22.75 1.58579 22.4142 1.25 22 1.25H18C17.5858 1.25 17.25 1.58579 17.25 2C17.25 2.41421 17.5858 2.75 18 2.75H19.25V15.25H18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42363 2.21389L2.24037 7.75339C1.72688 8.21342 2.09056 9 2.81675 9H4.1V14.6C4.1 15.3732 4.7268 16 5.5 16H12.5C13.2732 16 13.9 15.3732 13.9 14.6V9H15.1833C15.9094 9 16.2731 8.21342 15.7596 7.75339L9.57637 2.21388C9.25805 1.9287 8.74195 1.92871 8.42363 2.21389Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.25C2.41421 17.25 2.75 17.5858 2.75 18V19.25H15.25V18C15.25 17.5858 15.5858 17.25 16 17.25C16.4142 17.25 16.75 17.5858 16.75 18V22C16.75 22.4142 16.4142 22.75 16 22.75C15.5858 22.75 15.25 22.4142 15.25 22V20.75H2.75V22C2.75 22.4142 2.41421 22.75 2 22.75C1.58579 22.75 1.25 22.4142 1.25 22V18C1.25 17.5858 1.58579 17.25 2 17.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePlanAlt4);
export default __webpack_public_path__ + "static/media/house-plan-alt-4.9c54036a47b47c994fc5a62e5991b495.svg";
export { ForwardRef as ReactComponent };